var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209.23718mm",
    height: "160.27887mm",
    viewBox: "0 0 209.23718 160.27887",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-0.33092763,-0.89301877)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      overflow: "hidden",
      fill: "#bbb",
      fillOpacity: 1
    },
    id: "g18",
    transform: "matrix(0.33998866,0,0,0.33091402,-67.558008,-86.531818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 507.904,264.192 c 73.728,0 133.12,59.392 133.12,133.12 v 33.792 c -44.032,-5.12 -89.088,-7.168 -133.12,-7.168 -44.032,0 -89.088,2.048 -133.12,7.168 v -33.792 c 0,-72.704 59.392,-133.12 133.12,-133.12 z m 241.664,389.12 13.312,-116.736 c 29.696,5.12 52.224,29.696 52.224,57.344 0,32.768 -29.696,59.392 -65.536,59.392 z m -484.352,0 c -35.84,0 -65.536,-26.624 -65.536,-59.392 0,-28.672 22.528,-52.224 52.224,-57.344 z M 703.488,459.776 c -67.584,-7.168 -132.096,-10.24 -194.56,-10.24 -62.464,0 -128,3.072 -194.56,10.24 -22.528,2.048 -38.912,22.528 -35.84,44.032 l 20.48,198.656 c 2.048,18.432 16.384,33.792 35.84,35.84 57.344,7.168 115.712,10.24 175.104,10.24 59.392,0 117.76,-3.072 175.104,-10.24 18.432,-2.048 33.792,-17.408 35.84,-35.84 l 20.48,-198.656 c 0,-22.528 -15.36,-41.984 -37.888,-44.032 z M 395.264,640 c -16.384,0 -28.672,-16.384 -28.672,-37.888 0,-21.504 13.312,-37.888 28.672,-37.888 15.36,0 28.672,16.384 28.672,37.888 0,21.504 -12.288,37.888 -28.672,37.888 z m 171.008,41.984 c 0,2.048 -1.024,4.096 -2.048,5.12 -1.024,1.024 -3.072,2.048 -5.12,2.048 H 457.728 c -2.048,0 -4.096,-1.024 -5.12,-2.048 -1.024,-1.024 -2.048,-3.072 -2.048,-5.12 v -18.432 c 0,-4.096 3.072,-7.168 7.168,-7.168 h 2.048 c 4.096,0 7.168,3.072 7.168,7.168 v 9.216 h 82.944 v -9.216 c 0,-4.096 3.072,-7.168 7.168,-7.168 h 2.048 c 4.096,0 7.168,3.072 7.168,7.168 z M 620.544,640 c -16.384,0 -28.672,-16.384 -28.672,-37.888 0,-21.504 13.312,-37.888 28.672,-37.888 15.36,0 28.672,16.384 28.672,37.888 0,21.504 -12.288,37.888 -28.672,37.888 z",
    id: "path9",
    style: {
      fill: "#bbb",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBot);
export default __webpack_public_path__ + "static/media/twitter-bot.247fa68897d3a6e3819d2287ba3c4648.svg";
export { ForwardRef as ReactComponent };